import React from 'react';
import Link from 'next/link';
import styles from '../../styles/blog/articleMeta.module.scss';

function formatDate(dateString) {
    if (!dateString) return '';
    const date = new Date(dateString);
    return date.toLocaleDateString('en-US', { month: 'long', day: 'numeric', year: 'numeric' });
}

export default function ArticleMeta({ author, publishedAt, readTime, category }) {
    return (
        <div className={styles.meta}>
            <div className={styles.left}>
                {author && (
                    <div className={styles.author}>
                        {author.avatar?.url && (
                            <img
                                src={author.avatar.url}
                                alt={author.name}
                                className={styles.avatar}
                            />
                        )}
                        <span className={styles.authorName}>{author.name}</span>
                    </div>
                )}
                <span className={styles.date}>{formatDate(publishedAt)}</span>
                {readTime && (
                    <>
                        <span className={styles.dot}></span>
                        <span className={styles.readTime}>{readTime} min read</span>
                    </>
                )}
            </div>
            {category && (
                <Link href={`/blog?category=${category.slug}`} className={styles.categoryLink}>
                    {category.name}
                </Link>
            )}
        </div>
    );
}
